(function () {
  'use strict';

  function productPriority(item) {
    var soldOut = item.getAttribute('data-product-available') === 'false';
    var hasImage = item.getAttribute('data-product-has-image') !== 'false';

    // Preserve stock-first behaviour, while pushing image-less products
    // to the bottom of their respective stock group.
    if (!soldOut && hasImage) return 0;
    if (!soldOut && !hasImage) return 1;
    if (soldOut && hasImage) return 2;
    return 3;
  }

  function reorderProducts() {
    var list = document.getElementById('main-collection-product-grid');
    if (!list || list.dataset.mipReordering === 'true') return;
    // Progressive collections are ordered by Liquid and the append loader.
    // Re-sorting previously rendered cards here moves the reader's current
    // row (and can repaint every image during trackpad momentum scrolling).
    if (list.closest('.collection-default[data-mip-auto-load-limit]')) return;

    var items = Array.prototype.slice.call(list.children).filter(function (node) {
      return node.classList && node.classList.contains('product');
    });
    if (items.length < 2) return;

    var indexed = items.map(function (item, index) {
      return { item: item, index: index, priority: productPriority(item) };
    });

    var needsReorder = false;
    for (var i = 1; i < indexed.length; i += 1) {
      if (indexed[i - 1].priority > indexed[i].priority) {
        needsReorder = true;
        break;
      }
    }
    if (!needsReorder) return;

    // Stable sort keeps Shopify's merchandising order inside each group.
    indexed.sort(function (a, b) {
      return (a.priority - b.priority) || (a.index - b.index);
    });

    list.dataset.mipReordering = 'true';
    indexed.forEach(function (entry) { list.appendChild(entry.item); });
    delete list.dataset.mipReordering;
  }

  var reorderScheduled = false;
  function scheduleReorder() {
    if (reorderScheduled) return;
    reorderScheduled = true;
    requestAnimationFrame(function () {
      reorderScheduled = false;
      reorderProducts();
    });
  }

  // The top filters own real controls; the original facet form remains the
  // single request source. No click is forwarded to a sidebar heading.
  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text != null) node.textContent = text;
    return node;
  }
  function labelText(value) {
    var text = String(value || '').replace(/\([^)]*\)\s*$/, '').replace(/^Select\s+/i, '').trim();
    if (/^(color|colour)$/i.test(text)) return 'Colour';
    if (/^(departments?|product type|type)$/i.test(text)) return 'Style';
    if (/^(vendor|brand)$/i.test(text)) return 'Brand';
    return text;
  }
  var solidColours = {
    black: '#111111', white: '#fafaf8', 'off white': '#f4f1e8', cream: '#f3ead3',
    navy: '#182b49', blue: '#557fa8', 'light blue': '#9fc5e8', 'dark blue': '#1f3557',
    brown: '#79513a', 'dark brown': '#4b2e24', tan: '#b97845', camel: '#b78655',
    beige: '#d8c5a5', natural: '#d8c7a8', taupe: '#9a8b7c', cameo: '#d9b6a3',
    burgundy: '#6d213c', red: '#a62f35', pink: '#d9a3b5', fuchsia: '#c43b78', fuschia: '#c43b78',
    grey: '#8a8a8a', gray: '#8a8a8a', silver: '#b9bcc1', pewter: '#8a8d8f',
    gold: '#c7a34d', 'rose gold': '#b76e79', champagne: '#d6bd8a', bronze: '#9a6a3a',
    green: '#487052', 'light green': '#a8c8a0', 'dark green': '#244c35', sage: '#9caf88',
    olive: '#68704a', khaki: '#7d7a52', mint: '#a8d5ba', teal: '#2f7f7a', turquoise: '#40aeb2',
    purple: '#76527f', orange: '#c8773a', yellow: '#d8bd55'
  };
  function swatchNode(option, small) {
    var swatch = el('span', 'mip-facet-swatch' + (small ? ' mip-facet-swatch--small' : ''));
    swatch.setAttribute('aria-hidden', 'true');
    var key = option.label.toLowerCase().replace(/-/g, ' ').trim();
    var complex = /print|leopard|snake|cow|tiger|multi|mix|sequin|raffia/.test(key);
    var colour = option.color || (!complex && solidColours[key]);
    if (colour && CSS.supports('color', colour)) swatch.style.backgroundColor = colour;
    else if (option.image) {
      try {
        var url = new URL(option.image, location.origin);
        if (/^https?:$/.test(url.protocol)) swatch.style.backgroundImage = 'url(' + JSON.stringify(url.href) + ')';
      } catch (ignore) { /* A label is always present, even without a swatch. */ }
    } else swatch.classList.add('mip-facet-swatch--unknown');
    swatch.title = option.label;
    return swatch;
  }

  class MipTopFilters {
    constructor(bar) {
      this.bar = bar;
      this.section = bar.closest('.collection-default');
      this.form = this.section.querySelector('#CollectionFiltersForm');
      this.content = this.section.querySelector('[data-mip-collection-content]');
      this.sidebar = this.section.querySelector('#halo-sidebar');
      this.chips = bar.querySelector('[data-mip-filter-chips]');
      this.panel = bar.querySelector('[data-mip-filter-popover]');
      this.openKey = null;
      this.search = '';
      this.priceDraft = null;
      this.frame = null;
      this.timer = null;
      this.listeners = new AbortController();
      this.sidebarEnabled = this.section.dataset.mipSidebarEnabled !== 'false';
      this.collapsed = false;
      try { this.collapsed = sessionStorage.getItem('mipDesktopSidebarCollapsed') === 'true'; } catch (ignore) {}
      if (!this.sidebarEnabled) this.collapsed = true;
      this.section.classList.add('mip-topfilters-layout', 'mip-topfilters-ready');
      this.readState();
      this.refresh();
      this.setCollapsed(this.collapsed, false);
      this.bind();
      this.metrics();
    }
    listen(target, type, callback, options) {
      target.addEventListener(type, callback, Object.assign({}, options, { signal: this.listeners.signal }));
    }
    engine() { return customElements.get('collection-filters-form'); }
    readState() {
      var data = this.section.querySelector('[data-mip-filter-data]');
      try { this.state = JSON.parse(data.textContent); } catch (ignore) { this.state = { filters: [], sortOptions: [] }; }
      this.form = this.section.querySelector('#CollectionFiltersForm');
      this.groups = [];
      if (!this.form) return;
      var values = new Map();
      (this.state.filters || []).forEach(function (filter) {
        (filter.values || []).forEach(function (value) { values.set(value.name + '\n' + value.value, value); });
      });
      this.form.querySelectorAll('.sidebarBlock.js-filter').forEach((block) => {
        if (block.classList.contains('refined-widgets')) return;
        var heading = block.querySelector('.facets__text') || block.querySelector('.sidebarBlock-heading');
        if (!heading) return;
        var label = labelText(heading.textContent);
        var isCategory = this.state.categoryEnabled !== false && this.state.categoryParam && block.dataset.mipFilterKey === this.state.categoryParam;
        if (isCategory) label = 'Category';
        var key = String(block.dataset.index || this.groups.length);
        var numbers = Array.from(block.querySelectorAll('input[type="number"][name]'));
        var isPrice = numbers.length === 2;
        var options = [];
        var seen = new Set();
        block.querySelectorAll('input[type="checkbox"][name]').forEach((input) => {
          var lookup = input.name + '\n' + input.value;
          if (seen.has(lookup)) return;
          seen.add(lookup);
          var meta = values.get(lookup) || {};
          var item = input.closest('.facets__item') || input.parentElement;
          var labelNode = item.querySelector('label[for="' + CSS.escape(input.id) + '"]');
          var count = item.querySelector('.count');
          options.push({
            name: input.name, value: input.value, source: input,
            label: meta.label || (labelNode && labelNode.title) || input.value,
            sizeLabel: (labelNode && labelNode.querySelector('.text') && labelNode.querySelector('.text').textContent.trim()) || meta.label || input.value,
            count: meta.count != null ? Number(meta.count) : (count ? Number(count.textContent.replace(/[^0-9]/g, '')) : null),
            checked: input.checked, disabled: input.disabled && !input.checked,
            color: meta.color || '', image: meta.image || ''
          });
        });
        if (!isPrice && !options.length) return;
        this.groups.push({ key: key, label: label, block: block, options: options, numbers: numbers, isCategory: !!isCategory, top: !!isCategory || !block.hasAttribute('data-mip-placement') || block.dataset.mipPlacement.includes('top'),
          type: isPrice ? 'price' : (/colou?r/i.test(label) ? 'colour' : (/^size$/i.test(label) ? 'size' : 'list')) });
      });
      // Category must come from the real source form. Menu links are never
      // presented as filter values; missing setup is explained only in the editor.
      var priority = ['Category', 'Style', 'Size', 'Colour', 'Brand', 'Price', 'Material', 'Features'];
      this.groups.sort(function (a, b) {
        var x = priority.indexOf(a.label), y = priority.indexOf(b.label);
        return (x < 0 ? 99 : x) - (y < 0 ? 99 : y);
      });
    }
    group(key) { return this.groups.find(function (group) { return group.key === key; }); }
    activeCount(group) {
      return group.type === 'price' ? Number(group.numbers.some(function (input) { return input.value !== ''; })) : group.options.filter(function (option) { return option.checked; }).length;
    }
    trigger(key) {
      if (key === 'sort') return this.bar.querySelector('[data-mip-sort-toggle]');
      return Array.from(this.chips.querySelectorAll('[data-mip-filter-chip]')).find(function (button) { return button.dataset.filterIndex === key; });
    }
    refresh() {
      var focused = document.activeElement;
      var focusKey = focused && focused.dataset ? focused.dataset.mipFocus : null;
      var oldTrigger = focused && focused.closest('[data-mip-filter-chip]');
      var triggerKey = oldTrigger && oldTrigger.dataset.filterIndex;
      var scroll = this.panel.querySelector('.mip-popover-body');
      var scrollTop = scroll ? scroll.scrollTop : 0;
      this.readState();
      var fragment = document.createDocumentFragment();
      var total = 0;
      this.groups.forEach((group) => {
        total += this.activeCount(group);
        if (!group.top) return;
        var button = el('button', 'mip-filter-chip');
        button.type = 'button';
        button.dataset.mipFilterChip = '';
        button.dataset.filterIndex = group.key;
        button.setAttribute('aria-controls', this.panel.id);
        button.setAttribute('aria-haspopup', 'dialog');
        button.setAttribute('aria-expanded', String(this.openKey === group.key));
        button.appendChild(el('span', 'mip-filter-chip__label', group.label));
        var count = this.activeCount(group);
        if (count) {
          button.classList.add('is-active');
          button.appendChild(el('span', 'mip-filter-chip__count', count));
        }
        if (group.type === 'colour') {
          var choices = group.options.filter(function (option) { return count ? option.checked : !option.disabled; });
          var previews = el('span', 'mip-colour-preview');
          previews.setAttribute('aria-hidden', 'true');
          choices.slice(0, 4).forEach(function (option) { previews.appendChild(swatchNode(option, true)); });
          if (choices.length > 4) previews.appendChild(el('span', 'mip-colour-preview__more', '+' + (choices.length - 4)));
          button.appendChild(previews);
        }
        button.appendChild(el('span', 'mip-filter-chip__chevron'));
        button.lastChild.setAttribute('aria-hidden', 'true');
        button.setAttribute('aria-label', group.label + (count ? ', ' + count + ' selected' : '') + ', filter products');
        fragment.appendChild(button);
      });
      this.chips.replaceChildren(fragment);
      var badge = this.bar.querySelector('[data-mip-total-filter-count]');
      if (badge) { badge.textContent = total; badge.hidden = total === 0; }
      this.bar.querySelectorAll('[data-mip-initial-control]').forEach(function (button) { button.disabled = false; button.removeAttribute('data-mip-initial-control'); });
      var sortInput = this.form && this.form.querySelector('[name="sort_by"]');
      var sortValue = (sortInput && sortInput.value) || this.state.sortBy;
      var selected = (this.state.sortOptions || []).find(function (option) { return option.value === sortValue; });
      var sortLabel = this.bar.querySelector('[data-mip-sort-label]');
      if (sortLabel) sortLabel.textContent = selected ? selected.label : 'Featured';
      var countNode = this.section.querySelector('[data-mip-results-count]');
      if (countNode && this.state.count != null) countNode.textContent = this.section.querySelector('[data-mip-size-stock-note]') ? 'Available size matches' : this.state.count + (this.state.count === 1 ? ' product' : ' products');
      this.activeChips();
      var clearButton = this.bar.querySelector('[data-mip-clear-all]');
      if (clearButton) clearButton.disabled = !this.hasSelectedFilters();
      if (this.openKey && this.openKey !== 'sort' && (!this.group(this.openKey) || !this.group(this.openKey).top)) this.close(false);
      if (this.openKey) this.renderPanel();
      if (focusKey && this.openKey) {
        var replacement = Array.from(this.panel.querySelectorAll('[data-mip-focus]')).find(function (node) { return node.dataset.mipFocus === focusKey; });
        if (replacement) replacement.focus({ preventScroll: true });
        else this.panel.querySelector('[data-mip-close]').focus({ preventScroll: true });
        var body = this.panel.querySelector('.mip-popover-body');
        if (body) body.scrollTop = scrollTop;
      } else if (triggerKey && this.trigger(triggerKey)) this.trigger(triggerKey).focus({ preventScroll: true });
      this.scheduleMetrics();
    }
    activeChips() {
      var row = this.section.querySelector('[data-mip-active-filters]');
      if (!row) return;
      var fragment = document.createDocumentFragment();
      var count = 0;
      this.groups.forEach((group) => {
        var choices = group.type === 'price' && this.activeCount(group) ? [{ label: this.priceLabel(group), value: null }] : group.options.filter(function (option) { return option.checked; });
        choices.forEach((option) => {
          count += 1;
          var button = el('button', 'mip-active-chip', group.label + ': ' + option.label);
          button.type = 'button'; button.dataset.mipRemove = group.key;
          if (option.value != null) button.dataset.value = option.value;
          button.setAttribute('aria-label', 'Remove ' + group.label + ': ' + option.label);
          button.appendChild(el('span', '', '×')); button.lastChild.setAttribute('aria-hidden', 'true');
          fragment.appendChild(button);
        });
      });
      if (count) {
        var clear = el('button', 'mip-text-button', 'Clear all');
        clear.type = 'button'; clear.dataset.mipClearAll = '';
        fragment.appendChild(clear);
      }
      row.replaceChildren(fragment); row.hidden = !count;
    }
    priceLabel(group) {
      var symbol = this.state.currencySymbol || '';
      return symbol + (group.numbers[0].value || '0') + ' – ' + symbol + (group.numbers[1].value || group.numbers[1].max);
    }
    open(key, focus) {
      if (this.openKey === key) { this.close(true); return; }
      document.dispatchEvent(new CustomEvent('mip:surface:open', { detail: { surface: 'filters', owner: this.bar } }));
      this.close(false);
      this.openKey = key; this.search = ''; this.priceDraft = null;
      this.panel.hidden = false;
      if (!this.trigger(key)) { this.close(false); return; }
      this.trigger(key).setAttribute('aria-expanded', 'true');
      this.renderPanel(); this.positionPanel();
      if (focus !== false) {
        var first = this.panel.querySelector('.mip-popover-body [data-mip-toggle-option]:not(:disabled), .mip-popover-body input:not(:disabled), .mip-popover-body a[href]') || this.panel.querySelector('[data-mip-close]');
        if (first) first.focus({ preventScroll: true });
      }
    }
    close(restoreFocus) {
      var button = this.trigger(this.openKey);
      if (button) button.setAttribute('aria-expanded', 'false');
      this.panel.hidden = true; this.openKey = null; this.priceDraft = null;
      if (restoreFocus && button) button.focus({ preventScroll: true });
    }
    renderPanel() {
      var group = this.group(this.openKey);
      var sorting = this.openKey === 'sort';
      if (!group && !sorting) return;
      var relatedCategoryMenu = !sorting && group.isCategory && this.section.querySelector('template[data-mip-category-menu][data-mip-category-menu-mode="related-menu"]');
      var title = sorting ? 'Sort by' : group.label;
      var header = el('div', 'mip-popover-header');
      var copy = el('div');
      var heading = el('h2', '', title);
      heading.id = this.panel.getAttribute('aria-labelledby');
      copy.appendChild(heading);
      copy.appendChild(el('p', '', sorting ? 'Choose how products are ordered' : (relatedCategoryMenu ? 'Browse related collections' : (group.type === 'price' ? 'Set your price range' : 'Select one or more'))));
      header.appendChild(copy);
      var close = el('button', 'mip-popover-close', '×');
      close.type = 'button'; close.dataset.mipClose = ''; close.dataset.mipFocus = 'close'; close.setAttribute('aria-label', 'Close ' + title + ' filters');
      header.appendChild(close);
      var body = el('div', 'mip-popover-body');
      var categoryMenuActive = false;
      this.panel.className = 'mip-filter-popover mip-filter-popover--' + (sorting ? 'sort' : group.type);
      if (sorting) this.renderSort(body);
      else if (group.type === 'price') this.renderPrice(body, group);
      else {
        if (group.options.length > 8 && group.type === 'list') {
          var search = el('input', 'mip-option-search');
          search.type = 'search'; search.placeholder = 'Search ' + title.toLowerCase();
          search.setAttribute('aria-label', 'Search ' + title.toLowerCase());
          search.dataset.mipSearch = ''; search.dataset.mipFocus = 'search'; search.value = this.search;
          body.appendChild(search);
        }
        var fieldset = el('fieldset', 'mip-options mip-options--' + group.type);
        fieldset.appendChild(el('legend', 'visually-hidden', title));
        group.options.forEach((option) => {
          var chosen = option.checked;
          var optionName = group.type === 'size' ? option.sizeLabel : option.label;
          // One focusable control owns the square, text, count and row padding.
          // No label forwarding or second checkbox change event can race focus
          // dismissal or AJAX rendering. The original form owns submitted values.
          var choice = el('button', 'mip-option mip-option-button' + (option.disabled ? ' is-disabled' : '') + (chosen ? ' is-selected' : ''));
          choice.dataset.searchLabel = option.label.toLowerCase();
          choice.type = 'button';
          choice.disabled = option.disabled;
          choice.dataset.mipToggleOption = group.key;
          choice.dataset.mipParam = option.name;
          choice.dataset.mipValue = option.value;
          choice.dataset.mipFocus = option.name + '=' + option.value;
          choice.setAttribute('aria-pressed', String(chosen));
          choice.setAttribute('aria-label', optionName + (option.disabled ? ', unavailable with the current filters' : ''));
          if (group.type === 'list') {
            var check = el('span', 'mip-option-check');
            check.setAttribute('aria-hidden', 'true');
            choice.appendChild(check);
          }
          if (group.type === 'colour') choice.appendChild(swatchNode(option, false));
          choice.appendChild(el('span', 'mip-option-label', optionName));
          if (option.count != null && group.type !== 'size') choice.appendChild(el('span', 'mip-option-count', '(' + option.count + ')'));
          fieldset.appendChild(choice);
        });
        body.appendChild(fieldset);
        var noMatch = el('p', 'mip-search-empty', 'No matching options. Try a different search.');
        noMatch.hidden = true; noMatch.dataset.mipNoMatch = '';
        body.appendChild(noMatch);
        if (group.isCategory) categoryMenuActive = this.renderCategoryMenu(body, [search, fieldset, noMatch].filter(Boolean));
      }
      var footer = el('div', 'mip-popover-footer');
      if (!sorting && !categoryMenuActive) {
        var draftCount = this.activeCount(group);
        var clear = el('button', 'mip-text-button', 'Clear');
        clear.type = 'button'; clear.dataset.mipClearGroup = group.key; clear.dataset.mipFocus = 'clear';
        clear.disabled = draftCount === 0 && !this.priceDraft;
        footer.appendChild(clear);
        var note = el('span', 'mip-popover-selection', group.type === 'price' ? 'Includes all prices by default' : draftCount + ' selected');
        footer.appendChild(note);
        var done = el('button', 'mip-popover-done', group.type === 'price' ? 'Apply price' : 'Done');
        done.type = 'button'; done.dataset.mipFocus = 'done';
        if (group.type === 'price') done.dataset.mipApplyPrice = group.key;
        else done.dataset.mipClose = '';
        footer.appendChild(done);
      }
      this.panel.replaceChildren(header, body);
      if (!sorting && !categoryMenuActive) this.panel.appendChild(footer);
      this.searchOptions(); this.positionPanel();
    }
    renderCategoryMenu(body, nativeNodes) {
      var source = this.section.querySelector('template[data-mip-category-menu][data-mip-category-menu-mode="related-menu"]');
      if (!source || !source.content.firstElementChild) return false;
      var menu = source.content.firstElementChild.cloneNode(true);
      nativeNodes.forEach(function (node) { node.hidden = true; });
      body.insertBefore(menu, nativeNodes[0] || null);
      return true;
    }
    renderSort(body) {
      var fieldset = el('fieldset', 'mip-options mip-options--sort');
      fieldset.appendChild(el('legend', 'visually-hidden', 'Sort products'));
      var source = this.form.querySelector('[name="sort_by"]');
      var selected = source ? source.value : this.state.sortBy;
      (this.state.sortOptions || []).forEach((option, i) => {
        var label = el('label', 'mip-option');
        var input = el('input'); input.type = 'radio'; input.name = 'mip-top-sort'; input.value = option.value;
        input.id = this.panel.id + '-sort-' + i; label.htmlFor = input.id;
        input.checked = option.value === selected; input.dataset.mipSort = ''; input.dataset.mipFocus = 'sort-' + option.value;
        label.appendChild(input); label.appendChild(el('span', 'mip-option-label', option.label));
        fieldset.appendChild(label);
      });
      body.appendChild(fieldset);
    }
    renderPrice(body, group) {
      var cap = Number(group.numbers[1].max) || 1000;
      var draft = this.priceDraft || group.numbers.map(function (input) { return input.value; });
      var form = el('form', 'mip-price-form'); form.dataset.mipPriceForm = group.key; form.noValidate = true;
      var slider = el('div', 'mip-price-slider');
      ['Minimum price', 'Maximum price'].forEach((label, i) => {
        var input = el('input'); input.type = 'range'; input.min = '0'; input.max = Math.ceil(cap); input.step = '1';
        input.value = draft[i] === '' ? (i ? cap : 0) : draft[i];
        input.setAttribute('aria-label', label); input.dataset.mipRange = i; input.dataset.mipFocus = 'range-' + i;
        slider.appendChild(input);
      });
      form.appendChild(el('p', 'mip-price-limit', 'Available range: ' + (this.state.currencySymbol || '') + '0 – ' + (this.state.currencySymbol || '') + cap));
      form.appendChild(slider);
      var fields = el('div', 'mip-price-fields');
      ['From', 'To'].forEach((text, i) => {
        var field = el('div', 'mip-price-field');
        var label = el('label', '', text); label.htmlFor = this.panel.id + '-price-' + i; field.appendChild(label);
        var wrap = el('span'); wrap.appendChild(el('span', '', this.state.currencySymbol || ''));
        var input = el('input'); input.type = 'number'; input.min = '0'; input.max = cap; input.step = '1';
        input.inputMode = 'decimal'; input.placeholder = i ? cap : '0'; input.value = draft[i];
        input.id = label.htmlFor; input.dataset.mipPrice = i; input.dataset.mipFocus = 'price-' + i;
        input.setAttribute('aria-label', text + ' price'); wrap.appendChild(input);
        var steppers = el('span', 'mip-price-steppers');
        [1, -1].forEach((direction) => {
          var stepper = el('button', 'mip-price-step', direction === 1 ? '▴' : '▾');
          stepper.type = 'button'; stepper.dataset.mipStepPrice = String(i); stepper.dataset.mipStepDirection = String(direction);
          stepper.setAttribute('aria-label', (direction === 1 ? 'Increase ' : 'Decrease ') + text.toLowerCase() + ' price by 1 ' + (this.state.currency || ''));
          steppers.appendChild(stepper);
        });
        wrap.appendChild(steppers); field.appendChild(wrap); fields.appendChild(field);
      });
      form.appendChild(fields);
      var submit = el('button'); submit.type = 'submit'; submit.hidden = true; submit.textContent = 'Apply price'; form.appendChild(submit);
      var error = el('p', 'mip-price-error'); error.hidden = true; error.setAttribute('role', 'alert'); form.appendChild(error);
      body.appendChild(form);
    }
    stepPrice(index, direction) {
      var input = this.panel.querySelector('[data-mip-price="' + index + '"]');
      if (!input) return;
      var cap = Number(input.max), current = input.value === '' ? (index === '1' ? cap : 0) : Number(input.value);
      if (!Number.isFinite(current)) return;
      input.value = String(Math.max(0, Math.min(cap, Math.round((current + direction) * 100) / 100)));
      input.focus({ preventScroll: true });
      input.dispatchEvent(new Event('input', { bubbles: true }));
    }
    searchOptions() {
      var search = this.search.toLowerCase().trim();
      var visible = 0;
      this.panel.querySelectorAll('[data-search-label]').forEach(function (option) {
        option.hidden = !option.dataset.searchLabel.includes(search);
        if (!option.hidden) visible += 1;
      });
      var empty = this.panel.querySelector('[data-mip-no-match]');
      if (empty) empty.hidden = visible !== 0;
    }
    setCollapsed(collapsed, persist) {
      var canCollapse = this.sidebarEnabled && this.bar.dataset.mipSidebarCollapsible !== 'false';
      collapsed = !this.sidebarEnabled || (canCollapse && collapsed);
      this.collapsed = collapsed;
      this.section.classList.toggle('mip-sidebar-is-collapsed', collapsed);
      this.content.classList.toggle('mip-sidebar-collapsed', collapsed);
      this.section.querySelectorAll('[data-mip-sidebar-toggle]').forEach((button) => {
        button.setAttribute('aria-expanded', String(!collapsed));
        button.setAttribute('aria-label', collapsed ? 'Show filters' : 'Hide filters');
        button.disabled = !canCollapse;
        button.hidden = !this.sidebarEnabled;
      });
      if (this.sidebar) this.sidebar.inert = collapsed && window.innerWidth >= 1025;
      if (persist !== false && canCollapse) { try { sessionStorage.setItem('mipDesktopSidebarCollapsed', String(collapsed)); } catch (ignore) {} }
      this.scheduleMetrics();
    }
    setSource(option, checked) {
      // Match by actual parameter/value, never by a duplicate label or DOM ID.
      this.form.querySelectorAll('input[type="checkbox"][name]').forEach(function (input) {
        if (input.name === option.name && input.value === option.value) {
          input.checked = checked;
          var label = input.closest('.facets__label'); if (label) label.classList.toggle('active', checked);
        }
      });
    }
    submit() {
      var engine = this.engine();
      if (!engine || !this.form) { this.feedback('Filters are still loading. Please try again.', true); return; }
      var host = this.form.closest('collection-filters-form');
      var query = engine.serialize ? engine.serialize(this.form) : new URLSearchParams(new FormData(this.form)).toString();
      if (host && host.onConvertPrice) query = host.onConvertPrice(query);
      if (engine.scheduleRender) engine.scheduleRender(query, null);
      else engine.renderPage(query, null);
      this.refresh();
    }
    hasSelectedFilters() {
      if (!this.form) return false;
      return Array.from(this.form.elements).some(function(input) {
        if (!input.name || !input.name.startsWith('filter.')) return false;
        return /checkbox|radio/.test(input.type) ? input.checked : input.value !== '';
      });
    }
    clearAll() {
      if (!this.form || !this.hasSelectedFilters()) return;
      this.readState();
      this.groups.forEach(group => group.options.forEach(option => this.setSource(option, false)));
      Array.from(this.form.elements).forEach(function(input) {
        if (!input.name || !input.name.startsWith('filter.')) return;
        if (/checkbox|radio/.test(input.type)) input.checked = false;
        else input.value = '';
      });
      this.priceDraft = null;
      this.close(false);
      // Preserve sorting, current collection, locale, preview and non-filter query parameters.
      this.submit();
    }
    clearGroup(key, value) {
      var group = this.group(key); if (!group) return;
      if (group.type === 'price') group.numbers.forEach(function (input) { input.value = ''; });
      else group.options.forEach((option) => { if (value == null || value === option.value) this.setSource(option, false); });
      this.priceDraft = null; this.submit();
    }
    applyPrice(key) {
      var group = this.group(key), form = this.panel.querySelector('.mip-price-form');
      if (!group || !form) return;
      var inputs = Array.from(form.querySelectorAll('[data-mip-price]'));
      var cap = Number(group.numbers[1].max);
      var low = inputs[0].value === '' ? 0 : Number(inputs[0].value);
      var high = inputs[1].value === '' ? cap : Number(inputs[1].value);
      if (inputs.some(function (input) { return input.validity.badInput; }) || !Number.isFinite(low) || !Number.isFinite(high) || low < 0 || high < 0 || low > cap || high > cap || low > high) {
        var error = form.querySelector('.mip-price-error');
        error.textContent = 'Enter prices between 0 and ' + cap + ', with the minimum no higher than the maximum.'; error.hidden = false; return;
      }
      group.numbers[0].value = low === 0 ? '' : low;
      group.numbers[1].value = high === cap ? '' : high;
      this.priceDraft = null; this.close(true); this.submit();
    }
    feedback(message, error) {
      var node = this.section.querySelector('[data-mip-filter-feedback]'); if (!node) return;
      node.replaceChildren(el('span', '', message)); node.hidden = !message;
      node.classList.toggle('is-error', !!error);
      if (error) {
        var retry = el('button', 'mip-text-button', 'Try again'); retry.type = 'button'; retry.dataset.mipRetry = '';
        node.appendChild(retry);
      }
    }
    positionPanel() {
      if (!this.openKey || this.panel.hidden) return;
      var button = this.trigger(this.openKey); if (!button) return;
      var b = this.bar.getBoundingClientRect(), t = button.getBoundingClientRect();
      var width = this.openKey === 'sort' ? 290 : (this.group(this.openKey).type === 'colour' ? 370 : 340);
      width = Math.min(width, window.innerWidth - 32);
      var left = Math.max(16 - b.left, Math.min(t.left - b.left, window.innerWidth - b.left - width - 16));
      this.panel.style.width = width + 'px'; this.panel.style.left = left + 'px';
      var availableBelow = window.innerHeight - b.bottom - 24;
      var above = availableBelow < 230 && b.top > availableBelow;
      this.panel.style.top = above ? 'auto' : 'calc(100% + 8px)';
      this.panel.style.bottom = above ? 'calc(100% + 8px)' : 'auto';
      this.panel.style.maxHeight = Math.max(100, Math.min(520, above ? b.top - 24 : availableBelow)) + 'px';
    }
    metrics() {
      if (!this.section.isConnected) { this.destroy(); return; }
      if (window.innerWidth < 1025) { this.close(false); if (this.sidebar) this.sidebar.inert = false; return; }
      if (this.sidebar) this.sidebar.inert = this.collapsed;
      var bottom = 0;
      document.querySelectorAll('.section-header-navigation, .section-header-utility').forEach(function (header) {
        var r = header.getBoundingClientRect(), css = getComputedStyle(header);
        if (css.display !== 'none' && css.visibility !== 'hidden' && r.bottom > 0 && r.top <= 1 && /sticky|fixed/.test(css.position)) bottom = Math.max(bottom, r.bottom);
      });
      this.section.style.setProperty('--mip-sticky-top', Math.round(bottom) + 'px');
      var rect = this.bar.getBoundingClientRect();
      this.section.style.setProperty('--mip-filterbar-height', Math.ceil(rect.height) + 'px');
      this.bar.classList.toggle('is-stuck', rect.top <= bottom + 1 && window.scrollY > 10);
      var previous = this.bar.querySelector('[data-mip-chip-scroll="-1"]');
      var next = this.bar.querySelector('[data-mip-chip-scroll="1"]');
      var overflow = this.chips.scrollWidth > this.chips.clientWidth + 4;
      previous.hidden = !overflow; next.hidden = !overflow;
      previous.disabled = this.chips.scrollLeft < 2;
      next.disabled = this.chips.scrollLeft + this.chips.clientWidth >= this.chips.scrollWidth - 2;
      this.positionPanel();
    }
    scheduleMetrics() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = null; this.metrics(); });
    }
    bind() {
      this.listen(this.section, 'click', (event) => {
        var target = event.target.closest('button'); if (!target) return;
        if (target.matches('[data-mip-sidebar-toggle]')) {
          this.close(false); this.setCollapsed(!this.collapsed);
          // The secondary Hide filters button disappears with the sidebar.
          // Keep keyboard focus on the still-visible top-bar toggle.
          if (this.collapsed && target.classList.contains('mip-sidebar-hide')) {
            var toggle = this.bar.querySelector('[data-mip-sidebar-toggle]');
            if (toggle) toggle.focus({ preventScroll: true });
          }
        }
        else if (target.matches('[data-mip-filter-chip]')) this.open(target.dataset.filterIndex);
        else if (target.matches('[data-mip-sort-toggle]')) this.open('sort');
        else if (target.matches('[data-mip-close]')) this.close(true);
        else if (target.matches('[data-mip-chip-scroll]')) this.chips.scrollBy({ left: Number(target.dataset.mipChipScroll) * 220, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        else if (target.matches('[data-mip-clear-group]')) this.clearGroup(target.dataset.mipClearGroup);
        else if (target.matches('[data-mip-remove]')) this.clearGroup(target.dataset.mipRemove, target.dataset.value);
        else if (target.matches('[data-mip-clear-all]')) {
          this.clearAll();
        } else if (target.matches('[data-mip-apply-price]')) this.applyPrice(target.dataset.mipApplyPrice);
        else if (target.matches('[data-mip-retry]')) this.submit();
      });
      this.listen(this.panel, 'click', (event) => {
        var target = event.target instanceof Element ? event.target : event.target.parentElement;
        // Sorting alone uses native radio labels. Facets use one button per row.
        var stepper = target && target.closest('[data-mip-step-price]');
        if (stepper) { event.preventDefault(); event.stopPropagation(); this.stepPrice(stepper.dataset.mipStepPrice, Number(stepper.dataset.mipStepDirection)); return; }
        var row = target && target.closest('label.mip-option');
        var control = row && row.querySelector('input[data-mip-sort]');
        if (control && target !== control && this.panel.contains(row)) {
          event.preventDefault(); event.stopPropagation();
          if (control.disabled) return;
          control.focus({ preventScroll: true });
          var sortSource = this.form && this.form.querySelector('[name="sort_by"]');
          if (sortSource) { sortSource.value = control.value; this.close(true); this.submit(); }
          return;
        }
        var choice = target && target.closest('button[data-mip-toggle-option]');
        if (!choice || !this.panel.contains(choice)) return;
        event.preventDefault();
        event.stopPropagation();
        if (choice.disabled) return;
        // Refresh source references: AJAX replaces the original form's children.
        this.readState();
        var group = this.group(choice.dataset.mipToggleOption);
        var option = group && group.options.find(function (item) {
          return item.name === choice.dataset.mipParam && item.value === choice.dataset.mipValue;
        });
        if (!option || option.disabled) return;
        choice.focus({ preventScroll: true });
        this.setSource(option, !option.source.checked);
        // One shared request, without synthetic input/change/click events that
        // could trigger the sidebar and top handlers twice. Native buttons also
        // activate with Enter/Space, so no separate keyboard toggle is needed.
        this.submit();
      }, { capture: true });
      this.listen(this.panel, 'change', (event) => {
        var input = event.target;
        if (input.matches('[data-mip-sort]')) {
          event.stopPropagation();
          var source = this.form.querySelector('[name="sort_by"]');
          if (source) { source.value = input.value; this.close(true); this.submit(); }
        }
      });
      this.listen(this.panel, 'input', (event) => {
        var input = event.target;
        if (input.matches('[data-mip-search]')) { this.search = input.value; this.searchOptions(); }
        if (input.matches('[data-mip-range], [data-mip-price]')) {
          var fields = Array.from(this.panel.querySelectorAll('[data-mip-price]'));
          var ranges = Array.from(this.panel.querySelectorAll('[data-mip-range]'));
          if (input.matches('[data-mip-range]')) {
            var i = Number(input.dataset.mipRange);
            if (i === 0 && Number(input.value) > Number(ranges[1].value)) input.value = ranges[1].value;
            if (i === 1 && Number(input.value) < Number(ranges[0].value)) input.value = ranges[0].value;
            fields[i].value = Math.min(Number(fields[i].max), Number(input.value));
          } else {
            var index = Number(input.dataset.mipPrice);
            ranges[index].value = input.value || (index ? ranges[index].max : 0);
          }
          this.priceDraft = fields.map(function (field) { return field.value; });
          var clear = this.panel.querySelector('[data-mip-clear-group]'); if (clear) clear.disabled = false;
        }
      });
      this.listen(this.panel, 'keydown', (event) => {
        var input = event.target;
        if (!input.matches('[data-mip-price]') || !['ArrowUp', 'ArrowDown'].includes(event.key)) return;
        event.preventDefault();
        this.stepPrice(input.dataset.mipPrice, event.key === 'ArrowUp' ? 1 : -1);
      });
      this.listen(this.panel, 'submit', (event) => { event.preventDefault(); this.applyPrice(event.target.dataset.mipPriceForm); });
      this.listen(document, 'mip:surface:open', (event) => { if (event.detail && event.detail.owner !== this.bar) this.close(false); });
      this.listen(document, 'pointerdown', (event) => { if (this.openKey && !this.bar.contains(event.target)) this.close(false); });
      this.listen(document, 'keydown', (event) => {
        if (event.key === 'Escape' && this.openKey) { event.preventDefault(); this.close(true); }
        if (event.key === 'ArrowDown' && event.target.matches('[data-mip-filter-chip], [data-mip-sort-toggle]')) {
          event.preventDefault(); this.open(event.target.dataset.filterIndex || 'sort');
        }
      });
      this.listen(document, 'focusin', (event) => {
        // Clicking non-focusable text can focus the tabindex=-1 main ancestor
        // before click fires. That is not a move to a different control: closing
        // here removes the intended click target. Outside pointerdown and real
        // focus moves still dismiss the panel immediately.
        if (this.openKey && !this.bar.contains(event.target) && !event.target.contains(this.bar)) this.close(false);
      });
      this.listen(document, 'mip:collection:loading', () => { this.bar.setAttribute('aria-busy', 'true'); this.feedback('Updating products…', false); });
      this.listen(document, 'mip:collection:updated', () => {
        this.bar.removeAttribute('aria-busy'); this.feedback('', false); this.refresh();
      });
      this.listen(document, 'mip:collection:error', () => {
        this.close(false);
        this.bar.removeAttribute('aria-busy'); this.feedback('Products could not be updated. Your selection is kept; try again.', true);
      });
      this.listen(this.chips, 'scroll', () => this.scheduleMetrics(), { passive: true });
      this.listen(window, 'scroll', () => this.scheduleMetrics(), { passive: true });
      this.listen(window, 'resize', () => this.scheduleMetrics(), { passive: true });
      // Captures sidebar input changes immediately without submitting them twice.
      this.listen(this.form, 'input', () => { clearTimeout(this.timer); this.timer = setTimeout(() => this.refresh(), 30); });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.scheduleMetrics());
        this.resizeObserver.observe(this.bar);
      }
    }
    destroy() {
      this.listeners.abort(); clearTimeout(this.timer); cancelAnimationFrame(this.frame);
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.sidebar) this.sidebar.inert = false;
    }
  }

  var topFilters = null;
  var gridObserver = null;
  function resetCollectionHorizontalScroll() {
    if (!document.body.classList.contains('template-collection') || window.scrollX === 0) return;
    window.scrollTo(0, window.scrollY);
  }
  function init() {
    if (topFilters) { topFilters.destroy(); topFilters = null; }
    if (gridObserver) gridObserver.disconnect();
    var grid = document.getElementById('CollectionProductGrid');
    if (grid && !grid.closest('.collection-default[data-mip-auto-load-limit]')) {
      reorderProducts();
      gridObserver = new MutationObserver(scheduleReorder);
      gridObserver.observe(grid, { childList: true, subtree: true });
    }
    var bar = document.querySelector('[data-mip-filterbar]');
    if (bar && document.getElementById('CollectionFiltersForm')) {
      try { topFilters = new MipTopFilters(bar); }
      catch (error) { console.error('[Collection filters] Could not initialize controls:', error); }
    }
    // Safari can restore a previous horizontal document offset before the
    // responsive grid has finished measuring. Always restore the PLP origin.
    requestAnimationFrame(resetCollectionHorizontalScroll);
  }
  if (window.__mipCollectionUIInstalled) return;
  window.__mipCollectionUIInstalled = true;
  document.addEventListener('click', function (event) {
    var apply = event.target.closest('[data-mobile-filter-apply]');
    var reset = event.target.closest('[data-mobile-filter-reset]');
    if (!apply && !reset) return;
    var form = document.querySelector('collection-filters-form'); if (!form) return;
    if (apply && form.applyMobileFilters) form.applyMobileFilters(event);
    if (reset && form.resetMobileFilters) form.resetMobileFilters(event);
  });
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('pageshow', function () {
    requestAnimationFrame(resetCollectionHorizontalScroll);
  });
  document.addEventListener('shopify:section:unload', function () {
    if (topFilters && !topFilters.section.isConnected) { topFilters.destroy(); topFilters = null; }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
